import React, { useEffect, useState } from 'react';
import { Button } from "primereact/button";
import { IoReceiptOutline } from "react-icons/io5";


export const BtnUploadFileGeneral = ({ files, handleFileChange, handleButtonClick, typePerson, errors, name, deleteFileInTheList }) => {
    const [previewUrls, setPreviewUrls] = useState({});
    useEffect(() => {
        const newPreviewUrls = {};

        files.forEach((file, index) => {
            if (file.file && file.file instanceof File && file.file.size > 0) {
                newPreviewUrls[index] = URL.createObjectURL(file.file);
            } else {
                if (previewUrls[index]) {
                    URL.revokeObjectURL(previewUrls[index]);
                }
                newPreviewUrls[index] = null;
            }
        });

        setPreviewUrls(newPreviewUrls);

        // Cleanup para revocar las URLs anteriores cuando cambian los archivos
        return () => {
            Object.values(previewUrls).forEach(url => {
                if (url) {
                    URL.revokeObjectURL(url);
                }
            });
        };
    }, [files]);


    return (
        <>
            {files?.map((inputData, index) => (
                <div key={index} className="btnUpload mb-3 mx-auto ">
                    <div className="flex justify-between items-center " style={{ position: 'relative', width: '100%' }}>
                        <div className="flex flex-col" style={{ display: 'flex', width: '95%', gap: '1em', margin: 'auto' }}>
                            <input
                                type="file"
                                ref={inputData.ref}
                                style={{ display: 'none' }}
                                accept=".pdf, .jpg, .jpeg, .png"
                                onChange={(e) => handleFileChange(e, index)}
                            />
                            <Button
                                type="button"
                                icon={<IoReceiptOutline size={23} />}
                                outlined={true}
                                style={{ maxHeight: '70px', height: '70px' }}
                                className={`${inputData.isCharged ? 'Green' : (errors[`${name}.${index}`]) ? 'no-upload-error' : 'no-upload'} Receip py-3 w-full`}
                                label={`${inputData.label ? inputData.label === "" ? 'Subir archivo' : inputData.label == 'actaRpp' ? "Registro publico" : inputData.label : 'Subir archivo'}`}
                                onClick={() => handleButtonClick(index)}
                            />
                        </div>
                        {!inputData.required &&
                            <Button
                                icon="pi pi-times"
                                rounded
                                text
                                raised
                                severity="danger"
                                aria-label="Cancel"
                                style={{ width: '10%', height: '10%', margin: 'auto', position: 'absolute', right: '1.2em', top: '-10px', backgroundColor: 'white' }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    deleteFileInTheList(name, index);
                                }}
                            />
                        }
                    </div>
                    {inputData.file && previewUrls[index] ? (
                        <div className="w-full h-64 mt-2"
                            style={{
                                borderRadius: '0.5rem',
                                overflow: 'hidden',
                            }}
                        >
                            {inputData.file.type === 'application/pdf' ? (
                                <embed
                                    src={previewUrls[index]}
                                    type="application/pdf"
                                    className="w-full h-full"
                                    style={{
                                        borderRadius: '0.8rem',
                                    }}
                                />
                            ) : (
                                <img
                                    src={previewUrls[index]}
                                    alt="Preview"
                                    className="w-full h-auto max-h-10 object-contain"
                                    style={{
                                        maxHeight: '10rem',
                                        objectFit: 'contain',
                                        maxWidth: '100%',
                                        borderRadius: '1rem',
                                    }}
                                />
                            )}
                        </div>
                    ) : null}
                </div>
            ))}
        </>
    );
};
